import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initErrorReporter } from './utils/errorReporter';
import { SUPABASE_URL, SUPABASE_ANON_KEY } from './utils/env';

// Runtime error log (fleet-testing/shared/errors): crashes and failed backend calls from real
// browsers land in public.client_errors, read with `node shared/errors/triage.js`.
initErrorReporter({
  project: 'tradesmatepro',
  app: 'customer-portal',
  enabled: process.env.NODE_ENV === 'production' && !/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname),
  endpoint: `${SUPABASE_URL}/rest/v1/client_errors`,
  headers: { apikey: SUPABASE_ANON_KEY, Authorization: `Bearer ${SUPABASE_ANON_KEY}` },
  watchUrls: [`${SUPABASE_URL}/rest/v1/`, `${SUPABASE_URL}/functions/v1/`],
  ignoreHttp: (status) => status === 401,
  // The no-signup quote and payment links carry the access token in the path; it grants access
  // to that quote/invoice, so it never leaves the browser.
  redact: [
    [/\/public\/quote\/[^/?#\s]+/, '/public/quote/[token]'],
    [/\/public\/change-order\/[^/?#\s]+/, '/public/change-order/[token]'],
    [/\/payment\/(?!success|cancel)[^/?#\s]+/, '/payment/[token]'],
  ],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
